import { memo } from 'react'

import { Chip, Stack, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { videoStreamQueryKeys } from 'services/queryKeys'

import { ThumbnailPreview } from './ThumbnailPreview'

export type CameraStatusRowProps = {
  name?: string
  enabled: boolean
  resolvedThumbnailUrl?: string
  streamId?: string
}

const CameraStatusRowRaw = ({ name, enabled, resolvedThumbnailUrl, streamId }: CameraStatusRowProps) => {
  const { t } = useTranslation(['common', 'domain'])

  const streamQuery = useQuery({
    ...videoStreamQueryKeys.detail({ streamId: streamId! }),
    enabled: !!streamId,
  })
  const streamName = streamQuery.data?.name || streamId

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 1 }}>
      <ThumbnailPreview resolvedThumbnailUrl={resolvedThumbnailUrl} />
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="heading-sm" noWrap>
          {name || t('noNameProvided')}
        </Typography>
        <Typography variant="text-sm" color="text.secondary" noWrap>
          {streamName || '—'}
        </Typography>
      </Stack>
      <Chip
        size="small"
        variant="outlined"
        color={enabled ? 'success' : 'default'}
        label={
          enabled ? t('domain:Workspace.Event.ConfigEditor.enabled') : t('domain:Workspace.Event.ConfigEditor.disabled')
        }
      />
    </Stack>
  )
}

export const CameraStatusRow = memo(CameraStatusRowRaw)
